import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['choice']

  pickOwner() {
    const ownerId = this.choiceTarget.value

    fetch(
      `/sandbar/admin/session/switch_owner?owner_id=${ownerId}`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
        },
      }
    )
      .then(resp => {
        if (resp.ok) {
          location.reload();
          return resp.json()
        }
        resp.json().then(err => console.error(err))
      })
      .catch(err => console.error(err))
  }
}
